import React from "react";

const Home = () => {
    return (
        <div>
            <header>
                <h2>Home</h2>
            </header>
            <article>
                <p>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    Culpa, provident facere doloribus magnam eum aliquam.
                </p>
            </article>
        </div>
    );
};

export default Home;
